import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import purple from '@material-ui/core/colors/purple'

import profile from '../../static/profile.jpg'

import './index.css'

const MainHeader = () => (
  <Grid
    className='Header'
    container
    justify='center'
    component='header'
  >
    <Grid item xs={12} className='Header-content'>
      <Typography
        className='wow slideInLeft'
        data-wow-duration='2s'
        align='center'
        variant='h2'
        component='h1'
        style={{ color: '#fff' }}
      >
        Orlando Monteverde
      </Typography>
      <div
        className='Header-imgContainer wow slideInRight'
        data-wow-duration='2s'
      >
        <img
          src={profile}
          alt='Orlando Monteverde'
          className='Header-img'
        />
      </div>
      <Typography
        className='wow slideInLeft'
        data-wow-duration='2s'
        style={{ marginBottom: '1rem', color: '#fff' }}
        align='center'
        variant='h4'
        component='h3'
      >
        Web Developer
      </Typography>
      <Typography
        className='wow slideInRight'
        data-wow-duration='2s'
        style={{ color: purple[900], animation: '10s ColorChange infinite alternate' }}
        align='center'
        variant='h5'
        component='h4'
      >
        Resuelvo problemas
      </Typography>
    </Grid>
  </Grid>
)

export default MainHeader
